import {NEXT_PAGE, PREV_PAGE, HOME, END, GO_TO_PAGE, SET_PAGE_SIZE, SET_ITEMS_COUNT} from './PagingActions'

const initialState = {
    pageIndex: 0,       // aktuální index stránky
    pagesCount: 0,      // celkový počet stránek
    itemsCount: 0,      // počet záznamnů
    pageSize: 10,        // počet záznamnů na stránku
    currentDataKey: "",
    getDataKey: getDataKey,
    reducer: paging,
}

function getDataKey() {
    return JSON.stringify({
        pageIndex: this.pageIndex,
        // pagesCount: this.pagesCount,     // tyto NEHCEME!!!!!! nesouvisí s požadavkem na data!!!
        // itemsCount: this.itemsCount,
        pageSize: this.pageSize,
    });
}

const getPagesCount = (itemsCount, pageSize) => {
    var pagesCount = Math.floor(itemsCount / pageSize)
    if (itemsCount % pageSize > 0) {
        pagesCount++
    }
    return pagesCount
}

export default function paging(state = initialState, action = {}, config) {
    if (state === null) {   // může nastat, např. pokud u tabulky není inicializované stránkování
        return state
    }

    switch (action.type) {
        case NEXT_PAGE:
            if (state.pageIndex + 1 < state.pagesCount) {
                return {
                    ...state,
                    pageIndex: state.pageIndex + 1,
                }
            } else {
                return state
            }
        case PREV_PAGE:
            if (state.pageIndex > 0) {
                return {
                    ...state,
                    pageIndex: state.pageIndex - 1,
                }
            } else {
                return state
            }
        case HOME:
            return {
                ...state,
                pageIndex: 0,
            }
        case END:
            return {
                ...state,
                pageIndex: state.pagesCount - 1,
            }
        case GO_TO_PAGE:
            return {
                ...state,
                pageIndex: action.pageIndex
            }
        case SET_PAGE_SIZE:
            var state = {
                ...state,
                pageIndex: 0,
                pageSize: action.pageSize,
                pagesCount: getPagesCount(state.itemsCount, action.pageSize),
            }
        case SET_ITEMS_COUNT:
            const pagesCount = getPagesCount(action.itemsCount, state.pageSize)
            return {
                ...state,
                pageIndex: Math.max(0, Math.min(state.pageIndex, pagesCount - 1)),
                itemsCount: action.itemsCount,
                pagesCount: pagesCount,
            }
        default:
            return state
    }
}

